/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown>, count: NonNullable<unknown> }} Embed_Captions_Trial_Limit_FilesInputs */

const en_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your trial allows ${i?.remaining} more embed job(s), but ${i?.count} videos were selected. Remove some videos and try again.`)
};

const fr_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre essai autorise encore ${i?.remaining} tâche(s) d'intégration, mais ${i?.count} vidéos ont été sélectionnées. Retirez des vidéos et réessayez.`)
};

const de_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ihre Testversion erlaubt noch ${i?.remaining} Einbettungsjob(s), aber es wurden ${i?.count} Videos ausgewählt. Entfernen Sie einige Videos und versuchen Sie es erneut.`)
};

const it_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La tua prova consente ancora ${i?.remaining} lavoro/i di incorporamento, ma sono stati selezionati ${i?.count} video. Rimuovi alcuni video e riprova.`)
};

const ru_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пробная версия позволяет ещё ${i?.remaining} задани(я) на встраивание, но выбрано видео: ${i?.count}. Удалите часть видео и попробуйте снова.`)
};

const es_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Su prueba permite ${i?.remaining} trabajo(s) de incrustación más, pero se seleccionaron ${i?.count} videos. Quite algunos videos e inténtelo de nuevo.`)
};

const zh_cn2_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您的试用版还可提交 ${i?.remaining} 个嵌入任务，但已选择 ${i?.count} 个视频。请移除部分视频后重试。`)
};

const ja_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トライアルではあと ${i?.remaining} 件の埋め込みジョブが可能ですが、${i?.count} 本の動画が選択されています。動画を減らして再度お試しください。`)
};

const hi_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपका ट्रायल ${i?.remaining} और एम्बेड जॉब की अनुमति देता है, लेकिन ${i?.count} वीडियो चुने गए हैं। कुछ वीडियो हटाएँ और फिर से प्रयास करें।`)
};

const pt_pt2_embed_captions_trial_limit_files = /** @type {(inputs: Embed_Captions_Trial_Limit_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A sua avaliação permite mais ${i?.remaining} trabalho(s) de incorporação, mas foram selecionados ${i?.count} vídeos. Remova alguns vídeos e tente novamente.`)
};

/**
* | output |
* | --- |
* | "Your trial allows {remaining} more embed job(s), but {count} videos were selected. Remove some videos and try again." |
*
* @param {Embed_Captions_Trial_Limit_FilesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_trial_limit_files = /** @type {((inputs: Embed_Captions_Trial_Limit_FilesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Trial_Limit_FilesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_trial_limit_files(inputs)
	if (locale === "de") return de_embed_captions_trial_limit_files(inputs)
	if (locale === "it") return it_embed_captions_trial_limit_files(inputs)
	if (locale === "ru") return ru_embed_captions_trial_limit_files(inputs)
	if (locale === "es") return es_embed_captions_trial_limit_files(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_trial_limit_files(inputs)
	if (locale === "ja") return ja_embed_captions_trial_limit_files(inputs)
	if (locale === "hi") return hi_embed_captions_trial_limit_files(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_trial_limit_files(inputs)
	return en_embed_captions_trial_limit_files(inputs)
});